import { AxiosResponse } from 'axios';
import { all, takeEvery, put, call, select } from 'redux-saga/effects';
import { getCustomerContactApi } from "../../services/contact.service"
import { ClientWorkspace } from '../client/client.type';
import {ReducerType} from "../reducer.type";
import actions from "./actions"

const getWorkspace = (state: ReducerType) => state.client.owner.workspace;

function* GET_CONTACTS(action: {payload: string, type: string}){
    try{
        const workspace: ClientWorkspace = yield select(getWorkspace);
        const response: AxiosResponse<any> = yield call(getCustomerContactApi, workspace.uuid, action.payload);
        if (response){
            yield put({
                type: actions.SET_DATA,
                payload: response.data
            })
        }
    }
    catch (e) {
    }
}

export default function* RootSaga(){
    yield all([
        takeEvery(actions.GET_DATA, GET_CONTACTS)
    ])
}